import ClientListPageContainer from './containers/ClientListPageContainer'

export default ClientListPageContainer
